import { createAction, props } from '@ngrx/store';
import { IOrgUser } from '@care-portals/api-interfaces';

/* -------------------------------------------------------------------------- */
/*                                 Admin users                                */
/* -------------------------------------------------------------------------- */

/* ----------------------------- Get admin users ---------------------------- */

export const getAdminUsers = createAction(
  '[Admin User] Get Admin Users',
  props<{ query?: { name?: string; role?: string }, ignoreCache?: boolean }>()
);

export const getAdminUsersSuccess = createAction(
  '[Admin User] Get Admin Users Success',
  props<{ adminUsers: IOrgUser[], query}>()
);

export const getAdminUsersFailure = createAction(
  '[Admin User] Get Admin Users Failure',
  props<{ error: Error }>()
);

/* ---------------------------- Create admin user --------------------------- */

export const createAdminUser = createAction(
  '[Admin User] Create Admin User',
  props<{ adminUser: IOrgUser }>()
);

export const createAdminUserSuccess = createAction(
  '[Admin User] Create Admin User Success',
  props<{ adminUser: IOrgUser }>()
);

export const createAdminUserFailure = createAction(
  '[Admin User] Create Admin User Failure',
  props<{ error: Error }>()
);
export const startAddAdminUser = createAction(
  '[Admin User] Start Add Admin User'
);
export const cancelAddAdminUser = createAction(
  '[Admin User] Cancel Add Admin User'
);

/* ---------------------------- Update admin user --------------------------- */

export const updateAdminUser = createAction(
  '[Admin User] Update Admin User',
  props<{ adminUser: IOrgUser }>()
);

export const updateAdminUserSuccess = createAction(
  '[Admin User] Update Admin User Success',
  props<{ adminUser: IOrgUser }>()
);

export const updateAdminUserFailure = createAction(
  '[Admin User] Update Admin User Failure',
  props<{ adminUserId: string; error: Error }>()
);

export const startEditAdminUser = createAction(
  '[Admin User] Start Edit Admin User',
  props<{ adminUserId: string }>()
);

export const cancelEditAdminUser = createAction(
  '[Admin User] cancel Edit Admin User',
  props<{ adminUserId: string }>()
);

/* ---------------------------- Delete admin user --------------------------- */

export const deleteAdminUser = createAction(
  '[Admin User] Delete Admin User',
  props<{ adminUserId: string }>()
);

export const deleteAdminUserSuccess = createAction(
  '[Admin User] Delete Admin User Success',
  props<{ adminUserId: string }>()
);

export const deleteAdminUserFailure = createAction(
  '[Admin User] Delete Admin User Failure',
  props<{ error: Error }>()
);

/* ------------------------ Reset admin user password ----------------------- */

export const resetAdminUserPassword = createAction(
  '[Admin User] Reset Admin User Password',
  props<{ adminUserId: string }>()
);

export const resetAdminUserPasswordSuccess = createAction(
  '[Admin User] Reset Admin User Password Success'
);

export const resetAdminUserPasswordFailure = createAction(
  '[Admin User] Reset Admin User Password Failure',
  props<{ error: Error }>()
);

export const openResetAdminUserPasswordModal = createAction(
  '[Admin User] Open Reset Admin User Password Modal'
  // props<{ adminUserId: string }>()
);

export const closeResetAdminUserPasswordModal = createAction(
  '[Admin User] Close Reset Admin User Password Modal'
);

export const nullAction = createAction(
  '[Admin User] Null Action'
);